import * as React from 'react';
import * as styles from './index.css';

export interface IOfferCardServicePlaceUnderMapProps {
  markup?: string;
}

export class OfferCardServicePlaceUnderMap extends React.Component<IOfferCardServicePlaceUnderMapProps> {
  public constructor(props: IOfferCardServicePlaceUnderMapProps) {
    super(props);
    if (typeof document !== 'undefined' && document.querySelectorAll) {
      if (
        document.querySelectorAll(
          'script[src="https://cdn.cian.site/finance/offer-card-service-place-under-map/widget.js"]',
        ).length === 0
      ) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://cdn.cian.site/finance/offer-card-service-place-under-map/widget.js';
        document.head.appendChild(script);
      }
    }
  }

  public render() {
    if (!this.props.markup) {
      return null;
    }

    return (
      <div
        id="servicePlaceUnderMap"
        className={styles['container']}
        dangerouslySetInnerHTML={{ __html: this.props.markup }}
      />
    );
  }
}
